// Seed data for the Perjurnalan (Journal Template + Posting Rule) module,
// transcribed 1:1 from the reference DB export in
// src/views/app-views/coremenu/lms/jurnal/db.txt — stands in for the backend
// until the real `/lms/JurnalTemplate/*` endpoints exist, see
// JurnalTemplateService.js.

// Reference options — mirrors the "Transaction Type" master table in db.txt.
export const TRANSACTION_TYPE_OPTIONS = [
  { code: "ACT", name: "Aktivasi" },
  { code: "DSPR", name: "Disburse PO Supplier Request" },
  { code: "PAYRCV", name: "Pembayaran Customer" },
  { code: "SPR", name: "Suspend Receive" },
  { code: "SPC", name: "Suspend Correction/Reversal" },
];

const postingRule = (
  id,
  seq,
  glAccountId,
  drCr,
  sourceField,
  description,
  amountFormula,
  costCenterId,
  createdBy,
  createdDate,
  updatedBy,
  updatedDate
) => ({
  id,
  seq,
  glAccountId,
  category: "BR",
  branchId: 52,
  drCr, // "D" (Debit) | "C" (Kredit) — the actual posting side
  isDebit: drCr === "D",
  isCredit: drCr === "C",
  sourceField,
  description,
  amountFormula: amountFormula || "",
  isFormula: /[A-Z]+\(/.test(amountFormula || ""),
  costCenterId: costCenterId || "",
  createdBy,
  createdDate,
  updatedBy: updatedBy || createdBy,
  updatedDate: updatedDate || createdDate,
});

const dummyJurnalTemplate = [
  {
    id: 1,
    code: "ACT",
    name: "Jurnal Loan Activation",
    trxTypeCode: "ACT",
    type: "TRX",
    queryDefinitionName: "LoanByAppID",
    paramsJson: JSON.stringify(
      { param1: { paramName: "@loanno", paramDataType: "varchar" } },
      null,
      2
    ),
    resultCode: "TRX",
    createdBy: "system",
    createdDate: "2026-06-22 17:04:39.852",
    updatedBy: "system",
    updatedDate: "2026-06-22 17:04:39.852",
    postingRules: [
      postingRule(3, 1, "PRINC", "D", "ntf", "Piutang Pokok", "0", "", "system", "2026-06-22 17:04:40.361"),
      postingRule(4, 2, "INTRS", "D", "totalinterestamount", "Piutang Bunga", "0", "", "system", "2026-06-22 17:04:40.373"),
      postingRule(7, 3, "UINTRS", "C", "totalinterestamount", "Pendapatan Bunga ditangguhkan", "0", "", "system", "2026-06-22 17:04:40.410"),
      postingRule(11, 4, "UNINC", "D", "incentiveamount", "Insentif Supplier", "0", "", "system", "2026-06-22 17:04:40.465"),
      postingRule(8, 5, "UINSUR", "C", "komisi", "Pendapatan Komisi Asuransi ditangguhkan", "0", "", "system", "2026-06-22 17:04:40.428"),
      postingRule(12, 7, "UNPROVFEE", "C", "provfee", "Pendapatan Provisi ditangguhkan", "0", "", "system", "2026-06-22 17:04:40.633"),
      postingRule(13, 8, "FIDUFEE", "C", "fiduciafee", "Titipan fiducia", "0", "", "system", "2026-06-22 17:04:40.645"),
      postingRule(9, 9, "APINSURKB", "C", "insurancepremi", "Hutang Asuransi Kendaraan", "0", "", "system", "2026-06-22 17:04:40.442"),
      postingRule(10, 10, "APINSURLF", "C", "insurancelife", "Hutang Asuransi Jiwa", "0", "", "system", "2026-06-22 17:04:40.457"),
      postingRule(5, 11, "APINSURJK", "C", "insurancecredit", "Hutang Asuransi Kredit", "0", "", "system", "2026-06-22 17:04:40.381"),
      postingRule(6, 12, "APSUPPLIER", "C", "supplieramount", "Hutang Supplier", "0", "", "system", "2026-06-22 17:04:40.399"),
      postingRule(1, 13, "APINSENTIF", "C", "incentiveamount", "Insentive Supplier", "0", "", "system", "2026-06-22 17:04:40.270"),
      postingRule(2, 14, "EOTHFEE", "C", "otherfee", "Pendapatan Bunga ditangguhkan - Other Fee", "0", "", "system", "2026-06-22 17:04:40.345"),
    ],
  },
  {
    id: 2,
    code: "SPR",
    name: "Jurnal Suspend Receive",
    trxTypeCode: "SPR",
    type: "TRX",
    queryDefinitionName: "SuspendByVoucherNo",
    paramsJson: JSON.stringify(
      { param1: { paramName: "@voucherno", paramDataType: "varchar" } },
      null,
      2
    ),
    resultCode: "SPR",
    createdBy: "system",
    createdDate: "2026-06-23 16:59:22.391",
    updatedBy: "",
    updatedDate: "2026-06-23 16:59:22.391",
    postingRules: [
      postingRule(14, 1, "BankAccount.Coa", "D", "amount", "Suspend Receive Bank", "0", "", "system", "2026-06-23 10:37:08.405"),
      postingRule(15, 2, "SUSPEND-BANK", "C", "amount", "Suspend Transaksi Bank", "0", "", "system", "2026-06-23 10:37:08.405"),
    ],
  },
  {
    id: 3,
    code: "PAYMENT-RCV",
    name: "Pembayaran Customer",
    trxTypeCode: "PAYRCV",
    type: "TRX",
    queryDefinitionName: "BTByVoucherNo2",
    paramsJson: JSON.stringify(
      {
        param1: { paramName: "@branchid", paramDataType: "varchar" },
        param2: { paramName: "@ApplicationId", paramDataType: "varchar" },
        param3: { paramName: "@BankVoucher", paramDataType: "varchar" },
      },
      null,
      2
    ),
    resultCode: "PAYMENTRCV",
    createdBy: "SYSTEM",
    createdDate: "2026-06-25 15:26:57.346",
    updatedBy: "SYSTEM",
    updatedDate: "2026-06-25 15:26:57.346",
    postingRules: [
      postingRule(19, 1, "BankAccount.Coa", "D", "amount", "", "", "-", "SYSTEM", "2026-06-25 16:11:15.114"),
      postingRule(24, 2, "PRINC", "C", "princ", "Piutang Pokok", 'CONCATE(GLAccountID,FinType,FinScheme,"-",LocationID)', "831", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(25, 3, "INTRS", "C", "intrs", "Piutang Bunga", 'CONCATE(GLAccountID,FinType,FinScheme,"-",LocationID)', "831", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(26, 4, "LCINST", "C", "lcinst", "Pendapatan Denda", 'CONCATE(GLAccountID,FinType,FinScheme,"-",LocationID)', "831", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(27, 5, "GENPREPAID", "C", "genprepaid", "Titipan Nasabah Umum", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(28, 6, "INSTPREPAID", "C", "instprepaid", "Titipan Nasabah Angsuran", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(29, 7, "COLFEE", "C", "colfee", "Biaya Tagih", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(30, 8, "PDCBNCFEE", "C", "pdcbncfee", "Biaya Tolakan PDC", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(31, 9, "ARSTNK", "C", "arstnk", "PIUTANG ADVANCE STNK", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(32, 10, "BYREPO", "C", "byrepo", "BIAYA PENARIKAN", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(33, 11, "ARINSUR", "C", "arinsur", "PIUTANG ASURANSI NASABAH", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(34, 12, "LCINSUR", "C", "lcinsur", "LATE CHARGE INSURANCE", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(35, 13, "INSRCLAIM", "C", "insrclaim", "KLAIM ASURANSI", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(36, 14, "PLL", "C", "pll", "PENDAPATAN LAIN LAIN", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
      postingRule(37, 15, "EXPLL", "C", "expll", "BIAYA LAIN LAIN", "", "-", "SYSTEM", "2026-06-25 16:14:13.618"),
    ],
  },
  {
    id: 4,
    code: "SPC",
    name: "Jurnal Suspend Reversal",
    trxTypeCode: "SPC",
    type: "TRX",
    queryDefinitionName: "SuspendByVoucherNoSPC",
    paramsJson: JSON.stringify(
      { param1: { paramName: "@voucherno", paramDataType: "varchar" } },
      null,
      2
    ),
    resultCode: "SPC",
    createdBy: "system",
    createdDate: "2026-06-29 10:39:26.009",
    updatedBy: "",
    updatedDate: "2026-06-29 10:39:26.009",
    postingRules: [
      postingRule(41, 1, "SUSPEND-BANK", "D", "amount", "Suspend Transaksi Bank", "0", "", "system", "2026-06-26 17:14:29.615"),
      postingRule(40, 2, "BankAccount.Coa", "C", "amount", "Suspend Correction Bank", "0", "", "system", "2026-06-26 17:14:29.615"),
    ],
  },
];

export default dummyJurnalTemplate;
